/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_LearnInputs */

const en_directory_detail_signals_ai_stage_learn = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

const zh_directory_detail_signals_ai_stage_learn = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Directory_Detail_Signals_Ai_Stage_LearnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_learn = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_LearnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_LearnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_learn(inputs)
	return zh_directory_detail_signals_ai_stage_learn(inputs)
});
export { directory_detail_signals_ai_stage_learn as "directory.detail.signals.ai_stage.learn" }